<template>
  <a-spin :spinning="boxSpinning">
    <div id="steps-first">
      <h1>基本信息</h1>
      <a-form-model ref="firstForm" :labelCol="{ span: 8 }" :wrapperCol="{ span: 10 }" :model="firstForm.data" :rules="firstForm.rules">
        <a-form-model-item label="报告类型" prop="reportType">
          <a-select :disabled="firstForm.reportTypeDisabled" v-model="firstForm.data.reportType" placeholder="请选择报告类型">
            <a-select-option :value="1">校级团体报告</a-select-option>
            <a-select-option :value="2">区域团体报告</a-select-option>
            <a-select-option :value="3">单校对比报告</a-select-option>
            <a-select-option :value="4">多校对比报告</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-if="firstForm.data.reportType == 1" label="最小层级" prop="analyzeGranularity">
          <a-select v-model="firstForm.data.analyzeGranularity" placeholder="请选择最小层级">
            <a-select-option v-for="item in levelOptions" :value="item.value" :key="item.value">{{ item.label }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="报告名称" prop="name">
          <a-input @change="(e) => (firstForm.data.name = e.target.value.replace(/\s*/g, ''))" v-model="firstForm.data.name" :maxLength="35" placeholder="不超过35个字符">
            <span class="input-number" slot="suffix"> {{ firstForm.data.name ? firstForm.data.name.length : 0 }} / 35 </span>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="项目名称" prop="projectName">
          <a-input v-model="firstForm.data.projectName" :maxLength="35" placeholder="不超过35个字符">
            <span class="input-number" slot="suffix"> {{ firstForm.data.projectName ? firstForm.data.projectName.length : 0 }} / 35 </span>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="学段" prop="period">
          <a-select v-model="firstForm.data.period" placeholder="请选择学段">
            <a-select-option :value="0" title="学前">学前</a-select-option>
            <a-select-option :value="1" title="小学低年级">小学低年级</a-select-option>
            <a-select-option :value="2" title="小学高年级">小学高年级</a-select-option>
            <a-select-option :value="3" title="初中">初中</a-select-option>
            <a-select-option :value="4" title="高中">高中</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-if="firstForm.data.reportType == 1" label="报告内容" prop="reportModule">
          <div class="projectContent">
            <a-checkbox-group v-model="firstForm.data.reportModule" :options="projectContentOptions"> </a-checkbox-group>
          </div>
        </a-form-model-item>
        <a-form-model-item v-if="firstForm.data.reportType == 1" label="学习表格展示" prop="isContainContentScore">
          <a-radio-group v-model="firstForm.data.isContainContentScore" :options="reprtTableOptions"> </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="报告日期">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="reportDate" :wrapper-col="{ span: 24 }" style="margin-bottom: 0">
                <a-date-picker style="width: 100%" placeholder="请选择日期" v-model="firstForm.data.reportDate" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ span: 10, offset: 8 }" style="text-align: right">
          <a-button @click="cancel" style="margin-right: 20px">取消</a-button>
          <a-button type="primary" @click="onSubmit">下一步</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-spin>
</template>

<script>
import { FormatDate } from '@/pages/projectImpl/js/utils'
import $Bus from '@/pages/projectImpl/js/eventBus'
import moment from 'moment'

export default {
  name: 'StepsFirst',
  data() {
    return {
      moment,
      levelOptions: [
        {
          label: '年级',
          value: 1,
        },
        {
          label: '班级',
          value: 0,
        },
      ],
      reprtTableOptions: [
        {
          label: '有单个任务数据',
          value: true,
        },
        {
          label: '无单个任务数据',
          value: false,
        },
      ],
      projectContentOptions: [
        {
          label: '大脑学习能力',
          value: 1 << 0,
          disabled: true,
        },
        {
          label: '基础核心能力',
          value: 1 << 1,
          disabled: true,
        },
        {
          label: '能力分布',
          value: 1 << 2,
          disabled: true,
        },
        {
          label: '能力类型',
          value: 1 << 3,
          disabled: true,
        },
        {
          label: '创新拔尖人才',
          value: 1 << 5,
        },
        {
          label: '潜力分析',
          value: 1 << 4,
        },
      ],
      reportId: this.$parent.$props.reportId,
      //表单加载loading
      boxSpinning: false,
      firstForm: {
        isNowTime: true,
        reportTypeDisabled: false,
        data: {
          id: '',
          period: undefined,
          // projectCourseConfigId: "",
          name: '',
          nameCN: '',
          nameEN: '',
          projectName: '',
          reportDate: FormatDate(Date.now(), 'YYYY-MM-DD'),
          reportType: 1,
          studentSampleTakingMethod: 0,
          correctionMethod: 1,
          analyzeGranularity: 1,
          reportModule: [1, 2, 4, 8],
          isContainContentScore: false,
          // status: 0
        },
        rules: {
          nameCN: [
            { required: true, message: '请输入报告名称', trigger: 'blur' },
            { min: 2, max: 28, message: '报告名称长度为 2 到 28个字符', trigger: 'blur' },
          ],
          // projectName: [
          //   { required: false, message: '请输入项目名称', trigger: 'blur' },
          //   { min: 2, max: 35, message: '项目名称长度为 2 到 35个字符', trigger: 'blur' },
          // ],
          name: [
            { required: true, message: '请输入报告名称', trigger: 'blur' },
            { min: 2, max: 35, message: '报告名称长度为 2 到 35个字符', trigger: 'blur' },
            {
              validator: (_, value, callback) => {
                const reg = /^[a-zA-Z0-9\u4e00-\u9fa5()（）_]+$/
                if (!reg.test(value)) {
                  callback(new Error('报告名称不能包含特殊字符'))
                } else {
                  callback()
                }
              },
              trigger: 'blur',
            },
          ],
          period: [{ required: true, message: '请选择报告学段', trigger: 'change' }],
          //   reportDate: [{ required: true, message: '请选择日期', trigger: 'change' }],
          reportType: [{ required: true, message: '请选择报告类型', trigger: 'change' }],
          analyzeGranularity: [{ required: true, message: '请选择报告层级', trigger: 'change' }],
          reportModule: [{ required: true, message: '请选择报告内容', trigger: 'change' }],
        },
      },
    }
  },
  mounted() {
    this.getModel()
  },
  methods: {
    //根据id获取团体报告信息
    getModel() {
      if (this.reportId) {
        this.boxSpinning = true
        this.$http.ReportService.getGroupByCId(this.reportId)
          .then((res) => {
            this.boxSpinning = false
            const { data, status, message } = res
            this.$store.commit('organization/setReportInfo', data)
            for (let key in this.firstForm.data) {
              this.firstForm.data[key] = data[key]
            }
            if (data.reportDate && data.reportDate.split(' ')[0] !== FormatDate(Date.now(), 'YYYY-MM-DD')) {
              this.firstForm.isNowTime = false
              this.firstForm.data.reportDate = moment(this.firstForm.data.reportDate).format('YYYY-MM-DD')
            }
            this.firstForm.reportTypeDisabled = true
            const reportModule = []
            this.projectContentOptions.forEach((item) => {
              if (data.reportModule & item.value) {
                reportModule.push(item.value)
              }
            })
            this.firstForm.data.reportModule = reportModule
            console.log(this.firstForm.data)
          })
          .finally(() => {
            this.boxSpinning = false
          })
      } else {
        if (this.$store.getters['organization/getReportInfo'].id) {
          this.reportId = this.$store.getters['organization/getReportInfo'].id
          this.getModel()
        }
      }
    },
    //下一步
    onSubmit() {
      this.$refs['firstForm'].validate((valid) => {
        if (valid) {
          if (!this.reportId) {
            delete this.firstForm.data.id
          }
          const ReportInfo = { ...(this.$store.getters['organization/getReportInfo'] || {}) }
          for (let key in this.firstForm.data) {
            ReportInfo[key] = this.firstForm.data[key]
          }
          this.boxSpinning = true
          ReportInfo.reportModule = ReportInfo.reportModule.reduce((a, b) => a + b, 0)
          ReportInfo.reportDate = moment(this.firstForm.data.reportDate).format('YYYY-MM-DD HH:mm:ss')
          const requestReport = this.reportId ? this.$http.ReportService.editGroupReport : this.$http.ReportService.addGroupReport
          requestReport(ReportInfo)
            .then((res) => {
              const { data } = res
              this.$parent.$data.current = 1
              data && (ReportInfo.id = data)
              this.$store.commit('organization/setReportInfo', ReportInfo)
            })
            .finally(() => {
              this.boxSpinning = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //取消
    cancel() {
      $Bus.$emit('closeCreateReport')
    },
    //报告日期单选框切换
    firstFormRadioChange(e) {
      this.$refs.firstForm.clearValidate('reportDate')
      this.firstForm.data.reportDate = undefined
      if (e.target.value) {
        this.firstForm.data.reportDate = FormatDate(Date.now(), 'YYYY-MM-DD')
      }
      this.firstForm.rules.reportDate[0].required = !e.target.value
    },
  },
}
</script>

<style lang="less" scoped>
#steps-first {
  h1 {
    font-size: 20px;
    color: #333;
    margin-bottom: 30px;
  }
  .projectContent {
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #ccc8c8;
    ::v-deep .ant-checkbox-group {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
    }
  }
}
.input-number {
  font-size: 13px;
  color: #bbb;
}
</style>
